module.exports = __webpack_public_path__ + "prod/1.42.2/img/cycle-four.38e6021a.png";